/**
 * @file env.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene las variables de entorno
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2024-12-19
 * @author Correcta
 * @copyright © Correcta
 * @license Private
 * */

export const ENV = {
  PORT: process.env.PORT || 4000,
  NEXTAUTH_URL: process.env.NEXTAUTH_URL,
  NEXTAUTH_SECRET: process.env.NEXTAUTH_SECRET,
  NEXT_PUBLIC_BACKEND_URL:
    process.env.NEXT_PUBLIC_BACKEND_URL || "http://localhost:3000/api/v1",
  NEXT_PUBLIC_MINIO_HOST:
    process.env.NEXT_PUBLIC_MINIO_HOST || "localhost:9010",
  NEXT_PUBLIC_ENCRYPTION_PASSWORD:
    process.env.NEXT_PUBLIC_ENCRYPTION_PASSWORD ||
    "12345678901234567890123456789012",
};
